<div class="tax-container">
    <header>
        <nav-bar></nav-bar>
        <div class="header-wrapper">
            <div class="form-process-wrapper" aria-hidden="true">
                <div class="content no-padding">
                    <div class="form-process">
                        <div class="form-title">
                            <p>Tax Certification Form</p>
                        </div>
                        <div class="form-process-steps">
                            <div class="form-process-step filled">
                                <p>Form</p>
                                <div class="form-process-step-indicator">&nbsp;</div>
                            </div>
                            <div class="form-process-step filled">
                                <p>Review</p>
                                <div class="form-process-step-indicator">&nbsp;</div>
                            </div>
                            <div class="form-process-step filled">
                                <p>Complete</p>
                                <div class="form-process-step-indicator">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <main id="main">
        <div class="content-wrapper">
            <div class="content">
                <article class="main">
                    <h1>Tax Certification Process: Confirmation</h1>
                    <h2>
                        Reference Number: <span class="nowrap">{{referenceNumber}}</span>
                    </h2>
                    <p>Thank you for submitting your form. This will now be processed by your Broker. For any information about this process, or the status of your form, please contact your Broker.</p>
                    <p>Please print this page as a record of your Lodgement.</p>
                    <div class="button-area">
                        <div class="buttons-left">
                            <div>
                                <button ejs-button class="e-primary e-bigger" iconCss="e-icons e-check-icon" iconPosition="Right" (click)="FinishProcess();">Finished</button>
                            </div>
                            <div>
                                <button ejs-button class="e-bigger" iconCss="e-icons e-print-icon" iconPosition="Left" (click)="onPrint();">Print</button>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </main>
    <footer-bar></footer-bar>
</div>
